import React from "react";

const HeroSection = () => {
    return <>
        <h1 className="text-center main-heading mt-5 mb-3">Unlock the Power of Listening <br /> Welcome to VoiceBooker</h1>
        <p className="text-center main-desc mb-5">Experience the convenience of converting your PDFs and ePUBs into audio files instantly.</p>
    </>;
};

export default HeroSection;
